import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";
import { Area } from "./area.model";


@CwtModel({ name: 'city' })
@CwtCrudContract({ path: '/city', searchMapper: (s) => ({ name: { regexp: s } }) })
export class City extends CwtApiEntity {
    @CwtProp() name?: string;
    @CwtProp() zip?: string;
    @CwtProp({ ref: 'area' }) area: Area;
}
